import { canvas, Renderer } from 'leaflet';

export const MAP_RENDERER: Renderer = canvas({ tolerance: 8 });

// Maximum tiles to process for offline caching before skipping
// (prevents UI lockup on large geographic areas)
export const MAX_OFFLINE_TILES = 2000;
